// https://github.com/angular/material/pull/8397#issuecomment-249083288
export function mdAutocompleteProvider($provide) {
    'ngInject';
    // add additional function to md-autocomplete
    $provide.decorator('mdAutocompleteDirective', mdAutoCompleteDirectiveOverride);

    mdAutoCompleteDirectiveOverride.$inject = ['$delegate'];

    function mdAutoCompleteDirectiveOverride($delegate) {
        const directive = $delegate[0];
        // need to append to base compile function
        const compile = directive.compile;

        // add our custom attribute to the directive's scope
        angular.extend(directive.scope, {
            menuContainerClass: '@?mdMenuContainerClass'
        });

        // recompile directive and add our class to the virtual repeat container
        directive.compile = function (element, attr) {
            let template = compile.apply(this, arguments);
            let menuContainerClass = attr.mdMenuContainerClass ? attr.mdMenuContainerClass : '';
            let menuContainer = element.find('md-virtual-repeat-container');

            menuContainer.addClass(menuContainerClass);

            // recompile the template
            return function (e, a) {
                template.apply(this, arguments);
            };
        };

        return $delegate;
    }
}


// WEBPACK FOOTER //
// ./src/lib/components/autocomplete/md-autocomplete-provider.config.ts